export default "\r\n<app-menu></app-menu>\r\n<router-outlet></router-outlet>"